import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./footer.css";

const Footer = () => {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText("info@scaleAX.com");
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-top-grid">
          {/* Brand Col */}
          <div className="footer-brand-col">
            <Link to="/" className="footer-logo">
              <img src="/images/scaleAX.webp" alt="scaleAX" />
            </Link>
            <p className="footer-brand-tagline">
              Cross-border India market entry, growth, and execution partner for international companies — operating from Maryland and Chennai since 2011.
            </p>
            <div className="footer-badges">
              <span className="footer-pill-badge">
                <span className="dot"></span> 15+ Yrs Track Record
              </span>
              <span className="footer-pill-badge">
                <span className="dot"></span> Single Accountable IEO
              </span>
            </div>
          </div>

          {/* Service Lines */}
          <div className="footer-col">
            <h4>Service Lines</h4>
            <ul className="footer-links">
              <li>
                <Link to="/what-we-do">India Growth Engine</Link>
              </li>
              <li>
                <Link to="/what-we-do">India-to-World Platform</Link>
              </li>
              <li>
                <Link to="/what-we-do">Enterprise Sales & Key Accounts</Link>
              </li>
              <li>
                <Link to="/what-we-do">GeM & Public-Sector B2G</Link>
              </li>
              <li>
                <Link to="/what-we-do">Regional Hubs & GCC Setup</Link>
              </li>
              <li>
                <Link to="/what-we-do">Export & PLI Structuring</Link>
              </li>
            </ul>
          </div>

          {/* Navigation / Company */}
          <div className="footer-col">
            <h4>Company</h4>
            <ul className="footer-links">
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/how-we-work">How We Work</Link>
              </li>
              <li>
                <Link to="/case-studies">Case Studies</Link>
              </li>
              <li>
                <Link to="/careers">Careers</Link>
              </li>
              <li>
                <Link to="/resources">Market Insights</Link>
              </li>
              <li>
                <Link to="/contact">Book a Briefing Call</Link>
              </li>
            </ul>
          </div>

          {/* Dual Headquarters */}
          <div className="footer-col">
            <h4>Global Presence</h4>
            <div className="footer-offices">
              <div className="office-box">
                <div className="office-tag">INDIA HQ</div>
                <div className="office-name">Chennai, Tamil Nadu</div>
                <div className="office-addr">
                  143 / 1, Uthamar Gandhi Road, Nungambakkam, Chennai 600034
                </div>
              </div>
              {/* <div className="office-box">
                <div className="office-tag">US OFFICE</div>
                <div className="office-name">Rockville, Maryland</div>
                <div className="office-addr">
                  1 Research Court, Ste 450, Rockville, MD 20850, USA
                </div>
              </div> */}
            </div>

            <div className="footer-contact-actions">
              <button onClick={handleCopyEmail} className="footer-contact-btn" title="Copy Email">
                ✉ {copied ? "Copied info@scaleAX.com!" : "info@scaleAX.com"}
              </button>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-contact-btn"
              >
                LinkedIn ↗
              </a>
              <a
                href="https://whatsapp.com"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-contact-btn"
              >
                WhatsApp ↗
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div>© {new Date().getFullYear()} scaleAX. All rights reserved. Single Accountable India Execution Office.</div>
          <div className="footer-bottom-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/how-we-work">Terms & Engagement</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
